import React from "react";
import styled, { keyframes } from "styled-components";

import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Ceda from "../../assets/optimized/ceda.webp";
import Nvidia from "../../assets/optimized/nvidia.webp";
import Bih from "../../assets/optimized/bih.webp";
import Orange from "../../assets/optimized/orange.webp";
import GoAgro from "../../assets/optimized/goagro.webp";
import Microsoft from "../../assets/optimized/microsoft.webp";
import Bif from "../../assets/optimized/bif.webp";
import Spectrum from "../../assets/optimized/spectrum-analytics.webp"
import MongoDB from "../../assets/optimized/mongo.webp"

// Animation keyframes for Partners bubbles
const partnerFloat = keyframes`
  0%, 100% {
    transform: translateY(0px) translateX(0px) scale(1);
    opacity: 0.6;
  }
  50% {
    transform: translateY(-15px) translateX(8px) scale(1.1);
    opacity: 0.8;
  }
`;

// Animated background component for Partners
const PartnersAnimatedBackground = () => (
  <PartnersBackgroundContainer>
    <PartnersFloatingOrb delay="0s" size="60px" />
    <PartnersFloatingOrb delay="2s" size="85px" />
    <PartnersFloatingOrb delay="4s" size="75px" />
    <PartnersFloatingOrb delay="1s" size="90px" />
    <PartnersFloatingOrb delay="3s" size="55px" />
  </PartnersBackgroundContainer>
);

export default function Partners() {

   const partnerLogos = [
    {
      name: Nvidia,
      index: 0,
    },
    {
      name: Microsoft,
      index: 1,
    },
    {
      name: Bif,
      index: 2,
    },
    {
      name: Bih,
      index: 3,
    },
    {
      name: Ceda,
      index: 4,
    },
    {
      name: Spectrum,
      index: 5,
    },
    {
      name: Orange,
      index: 6,
    },
    {
      name: MongoDB,
      index: 7,
    },
    {
      name: GoAgro,
      index: 8,
    }
  ];

  // Carousel settings
  const carouselSettings = {
    dots: true,
    infinite: true,
    speed: 500,
    autoplay: true,
    slidesToShow: 5,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 2,
        },
      },
    ],
  };

  return (
    <Wrapper id="partners">
      <div className="whiteBg" style={{ position: "relative", overflow: "hidden" }}>
        <PartnersAnimatedBackground />
        <div className="container" style={{ position: "relative", zIndex: 2 }}>
          <HeaderInfo>
            <h1 className="font40 extraBold">Strategic Partners</h1>
            <p className="font16">
              Our partners are industry leaders and innovation platforms that power our growth. Through strategic collaborations with NVIDIA Inception, Microsoft for Startups, and leading tech partners, we leverage cutting-edge resources to deliver enterprise-grade intelligence solutions across Africa.
            </p>
          </HeaderInfo>
          <section>
          <Slider {...carouselSettings}>
            {partnerLogos.map((logo, index) => {
              return (
              <div key={index}>
                <LogoContainer>
                  <img 
                    src={logo?.name} 
                    alt="Partner Logo" 
                    width={150} 
                    height={80} 
                    style={{ 
                      width: '100%', 
                      height: '80px', 
                      objectFit: 'contain',
                      objectPosition: 'center'
                    }} 
                  />
                </LogoContainer>
              </div>
              )
              })} 
          </Slider>
          </section>
          </div>
      </div>
    </Wrapper>
  );
}

const Wrapper = styled.section`
  width: 100%;
  padding: 100px 0;
  background: linear-gradient(135deg, rgba(7, 148, 135, 0.02) 0%, rgba(7, 148, 135, 0.02) 100%);
`;

const HeaderInfo = styled.div`
  margin-bottom: 60px;
  text-align: center;
  
  h1 {
    margin-bottom: 20px;
    background: linear-gradient(135deg, #079487 0%, #079487 100%);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    background-clip: text;
  }
  
  p {
    color: #666;
    max-width: 600px;
    margin: 0 auto;
    line-height: 1.6;
  }
  
  @media (max-width: 860px) {
    text-align: center;
  }
`;

const LogoContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px;
  height: 120px;
  
  &:hover {
    transform: scale(1.05);
    transition: transform 0.3s ease;
  }
`;

// Partners section animated background components
const PartnersBackgroundContainer = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  overflow: hidden;
  z-index: 1;
`;

const PartnersFloatingOrb = styled.div`
  position: absolute;
  width: ${props => props.size || '60px'};
  height: ${props => props.size || '60px'};
  border-radius: 50%;
  background: linear-gradient(135deg, rgba(7, 148, 135, 0.08) 0%, rgba(25, 118, 210, 0.06) 100%);
  animation: ${partnerFloat} 12s ease-in-out infinite;
  animation-delay: ${props => props.delay};
  
  &:nth-child(1) {
    top: 20%;
    right: 15%;
  }
  
  &:nth-child(2) {
    bottom: 30%;
    left: 10%;
  }
  
  &:nth-child(3) {
    top: 70%;
    right: 25%;
  }
  
  &:nth-child(4) {
    top: 50%;
    left: 30%;
  }
  
  &:nth-child(5) {
    bottom: 15%;
    right: 40%;
  }
`;
